import { z } from "zod"

// Version 1 ---------------------
export const HeadingSettingsV1 = z.object({
  type: z.union([
    z.literal("h1"),
    z.literal("h2"),
    z.literal("h3"),
    z.literal("h4"),
    z.literal("h5"),
    z.literal("h6"),
  ]),
  initialStyles: z.object({}).passthrough().optional(),
})

export type THeadingSettingsV1 = z.infer<typeof HeadingSettingsV1>

export const HeadingElementV1 = z.object({
  id: z.string(),
  name: z.literal("heading"),
  settings: HeadingSettingsV1,
})

export type THeadingElementV1 = z.infer<typeof HeadingElementV1>

// Latest ---------------------
export const HeadingSettings = HeadingSettingsV1
export type THeadingSettings = THeadingSettingsV1
export const HeadingElement = HeadingElementV1
export type THeadingElement = THeadingElementV1
